export default "__VITE_ASSET__BIvAy8KD__"